// extracted by mini-css-extract-plugin
module.exports = {"root":"headerRightSlot_root__3ZW00","button":"headerRightSlot_button__3ftuh","buttonLabel":"headerRightSlot_buttonLabel__1IvjB","buttonIcon":"headerRightSlot_buttonIcon__1FF3E"};